/* @ngInject */
const emailLabels = () => {
  const self = {}

  self.email = 'Mail'

  self.fields = {
    email: {
      text: 'E-mail',
    },
  }

  self.name = (_size = 0, _point = false) => {
    return 'Mail' + (_size > 1 ? 's' : '') + (_point ? ' : ' : '')
  }
  self.empty = 'Aucun mail'

  self.success = {
    delete: 'Le mail a bien été supprimé',
  }
  self.ask = {
    delete: 'Êtes-vous sûr de vouloir supprimer ce mail ?',
  }

  self.log = {
    delete: {
      success: 'L\'email a bien été supprimé.',
      failure: 'Une erreur a interrompu la suppression de cet email.',
    },
  }

  return self
}

export default emailLabels



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/email/resources/labels.resource.js